export const CursorUp = 38;
export const CursorDown = 40;
export const Enter = 13;
export const Escape = 27;
export const Control = 17;
